import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import ET3Div from "../../../../../../core/et3-div";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { getKhattabatResultsStore } from "../../../../../../stores/khattabat-stores/results-store";

const CloseOpenConversation = withLiteObserverAndTheme<{
  matchID: number;
  isOpenedConversation: boolean;
  alkhattabaUUID: string;
  matchUUID: string;
}>((props) => {
  const { theme, isOpenedConversation, matchID, matchUUID, alkhattabaUUID } =
    props;
  const { colors } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={80}
      height={80}
      color={colors.all.transparent}
      style={{ cursor: "pointer" }}
      onClick={() =>
        getKhattabatResultsStore().toggleMatchConversationOpenState({
          matchID,
          alkhattabaUUID,
          clientUUID: matchUUID
        })
      }
    >
      <FontAwesomeIcon
        icon={!isOpenedConversation ? faChevronDown : faChevronUp}
        style={{ color: colors.all.blue }}
        size="3x"
      />
      <Et3Margin top={0} left={10} bottom={0} right={0} />
    </ET3Div>
  );
});
export default CloseOpenConversation;
